import React from 'react';
import { Header, WrapFiltersHeader, WrapFiltersHeaderColumn } from './Style';
import { Button, fieldsTyps } from 'components/Form';
import { assessmentsHooks } from 'pages/School/Assessments';
import CustomAutoComplete from 'pages/School/SystemReview/AssessmentResultsTracking/CustomAutoComplete';
import { Divider } from '@mui/material';
import { useSelector } from 'react-redux';
import { queryClient as qc } from 'keys';
import { getAssessmentDefsFetch } from 'store/middlewares/assessment.crud';
import { useQuery } from '@tanstack/react-query';
import { isEmpty, isArray } from 'lodash';

const AssessmentFiltersHeader = (props) => {
    const { keys, badge, hideSearchBtn, setAssessmentFilters, assessmentFilters, searchLabel, searchIcon, showLoading, headerItems = headerItemsP, disabledSearch, headercss, refetchData, loading, description, introLabel, searchButtonProps = {}, rowHeight } = props

    const headerItemsP = assessmentsHooks.useHeaderItems()
    const { headerFilters } = useSelector(state => state.header)

    const { data: assessmentDef } = useQuery({
        // תלוי גם ב-category (יחיד) וגם ב-categories (בחירה מרובה) - צרכנים שונים משתמשים בכל אחד מהם
        queryKey: [qc.assessmentDefs, assessmentFilters?.category, assessmentFilters?.categories, headerFilters],
        queryFn: ({ signal }) => {
            return getAssessmentDefsFetch({ headerFilters, assessmentFilters, signal, })
        },
        cacheTime: 300000,
        enabled: keys?.includes('category') && keys?.includes('assessment_def')
    })

    const handleChangeAssessmentsFilters = (key, value) => {
        const nAssessmentFilters = { ...assessmentFilters, [key]: value }
        setAssessmentFilters(nAssessmentFilters)
    }

    return (
        <WrapFiltersHeaderColumn>
        <WrapFiltersHeader height={rowHeight}>
            <Header headercss={headercss}>
                {introLabel &&
                    <span className='pill-label'>{introLabel}</span>}
                {headerItems.map((headerBtn, index) => {
                    let Component = fieldsTyps[headerBtn.component]
                    const value = assessmentFilters?.[headerBtn.name]
                    const hasValue = isArray(value) ? value.length > 0 : !!value

                    return (
                        headerBtn.hidden ||
                        <React.Fragment key={index}>
                            {headerBtn.dividerBefore &&
                                <Divider orientation="vertical" flexItem className='header-divider' />}
                            {headerBtn.pillLabel &&
                                <span className='pill-label'>{headerBtn.pillLabel}</span>}
                            <Component
                                {...headerBtn}
                                badge={badge}
                                fullwidth
                                options={headerBtn.name === 'assessment_def' ? assessmentDef?.data : headerBtn.options}
                                // pillStyle: תצוגת שדה "פתוחה" (ללא מסגרת, לייבל חיצוני) במקום תיבת הטקסט הרגילה - ר' CustomAutoComplete
                                renderCustomInput={headerBtn.pillStyle ?
                                    (params) => <CustomAutoComplete {...params} hasValue={hasValue} /> :
                                    headerBtn.renderCustomInput}
                                disabled={
                                    typeof headerBtn.disabled == 'function' ?
                                        headerBtn.disabled?.(assessmentFilters) :
                                        headerBtn.disabled}
                                input={{
                                    value: value,
                                    onChange: (value) => handleChangeAssessmentsFilters(headerBtn.name, value)
                                }}
                            />
                        </React.Fragment>
                    )
                })}
                {hideSearchBtn || isEmpty(headerItems) ||
                    <Button
                        variant="regular"
                        disabled={disabledSearch}
                        label={searchLabel || "סנן מבדקים"}
                        icon={searchIcon}
                        action={refetchData}
                        height={'40px'}
                        width={'108px'}
                        color={"thirdly1"}
                        loading={showLoading && loading}
                        {...searchButtonProps}
                    />}
            </Header>
        </WrapFiltersHeader>
        {description &&
            <div className='description-row'>
                {description}
            </div>
        }
        </WrapFiltersHeaderColumn>
    );
}

const isRender = (prev, next) => {
    return false
}

export default React.memo(AssessmentFiltersHeader, isRender)
